
export const customers = {
  title: "Customers",
  table: {
    name: "Name",
    email: "Email",
    totalSpent: "Total Spent",
    lastPurchase: "Last Purchase",
    purchaseCount: "Purchase Count",
    status: "Status",
    actions: "Actions"
  },
  purchases: {
    title: "Purchase History",
    all: "All",
    active: "Active",
    completed: "Completed",
    noPurchases: "No purchases found",
    noActivePurchases: "No active purchases",
    noCompletedPurchases: "No completed purchases",
    details: "Details",
    downloadInvoice: "Download Invoice",
    viewContent: "View Content",
    invoice: "Invoice",
    date: "Date",
    amount: "Amount",
    type: "Type",
    status: "Status",
    creator: "Creator",
    digitalContent: "Digital Content",
    consultation: "Consultation",
    videoRequest: "Video Request",
    package: "Package",
    statusActive: "Active",
    statusCompleted: "Completed"
  }
};
